import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use a timeout to ensure it works even when there's a transition or animation
    const scrollTimeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // use "smooth" if you want a scrolling effect
      });
    }, 0);

    return () => clearTimeout(scrollTimeout);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
